import styled from "styled-components";

const MessagePanelStyle = styled.div<any>`
  width: 100%;
  display: grid;
  grid-template-rows: 20px 1fr;
  padding: 12px;
  background: ${(props) =>
    props.mode === "error"
      ? props.theme.messagePanelErrorBackground
      : props.mode === "warning"
      ? props.theme.messagePanelWarningBackground
      : props.mode === "success"
      ? props.theme.messagePanelSuccessBackground
      : props.theme.messagePanelInfoBackground};
  color: ${(props) =>
    props.mode === "error"
      ? props.theme.messagePanelErrorText
      : props.mode === "warning"
      ? props.theme.messagePanelWarningText
      : props.mode === "success"
      ? props.theme.messagePanelSuccessText
      : props.theme.messagePanelInfoText};
  border-radius: 3px;
  position: relative;

  .title {
    display: grid;
    grid-template-columns: 20px 1fr;
    grid-gap: 8px;
  }

  .icon {
    font-size: 18px;
    color: ${(props) =>
      props.mode === "error"
        ? props.theme.messagePanelErrorIcon
        : props.mode === "warning"
        ? props.theme.messagePanelWarningIcon
        : props.mode === "success"
        ? props.theme.messagePanelSuccessIcon
        : props.theme.messagePanelInfoIcon};
  }

  .message {
    margin-left: 28px;
  }
`;

export default MessagePanelStyle;
